import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { login } from "../Tools/helpers";

const ResetPassword = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const email = searchParams.get("email") || "";

  const [form, setForm] = useState({ password: "", password_confirmation: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [message, setMessage] = useState({ status: false, message: "", success: false });
  const [loading, setLoading] = useState(false);

  const inputStyle = {
    width: '100%',
    padding: '10px 40px 10px 36px',
    border: '1px solid #334155',
    borderRadius: '7px',
    fontSize: '0.88rem',
    color: '#f1f5f9',
    outline: 'none',
    backgroundColor: '#0f172a',
    transition: 'border-color 0.15s, box-shadow 0.15s',
    marginTop: '6px',
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password !== form.password_confirmation) {
      setMessage({ status: true, message: "Las contraseñas no coinciden.", success: false });
      return;
    }
    if (!token || !email) {
      setMessage({ status: true, message: "Enlace inválido. Solicita uno nuevo.", success: false });
      return;
    }

    setLoading(true);
    setMessage({ status: false, message: "", success: false });

    const res = await login("reset-password", { email, token, ...form });
    setLoading(false);

    if (res.code === 200) {
      setMessage({ status: true, message: res.message, success: true });
    } else {
      setMessage({ status: true, message: res.message || "Ocurrió un error. Intenta de nuevo.", success: false });
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#0f172a',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '24px',
      position: 'relative',
      overflow: 'hidden',
    }}>
      <div style={{ position: 'absolute', top: '-80px', right: '-80px', width: '320px', height: '320px', borderRadius: '50%', backgroundColor: 'rgba(220,38,38,0.08)', pointerEvents: 'none' }} />
      <div style={{ position: 'absolute', bottom: '-60px', left: '-60px', width: '240px', height: '240px', borderRadius: '50%', backgroundColor: 'rgba(220,38,38,0.05)', pointerEvents: 'none' }} />

      <div style={{
        width: '100%',
        maxWidth: '400px',
        backgroundColor: '#1e293b',
        borderRadius: '14px',
        boxShadow: '0 25px 60px rgba(0,0,0,0.5)',
        border: '1px solid #334155',
        overflow: 'hidden',
      }}>
        <div style={{ height: '4px', backgroundColor: '#dc2626' }} />

        <div style={{ padding: '36px 32px 32px' }}>
          {/* Header */}
          <div style={{ textAlign: 'center', marginBottom: '28px' }}>
            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '16px' }}>
              <div style={{ backgroundColor: '#fff', borderRadius: '10px', padding: '8px 14px', display: 'inline-block' }}>
                <img src="/logo_iumv.png" alt="IUMV" style={{ height: '36px', display: 'block' }} onError={e => { e.target.style.display = 'none'; }} />
              </div>
            </div>
            <h1 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#f1f5f9', margin: 0, marginBottom: '6px' }}>
              Nueva contraseña
            </h1>
            <p style={{ fontSize: '0.78rem', color: '#94a3b8', margin: 0 }}>
              Ingresa tu nueva contraseña. Mínimo 8 caracteres.
            </p>
          </div>

          {message.status && (
            <div style={{
              display: 'flex', alignItems: 'flex-start', gap: '8px',
              backgroundColor: message.success ? 'rgba(16,185,129,0.1)' : 'rgba(220,38,38,0.1)',
              border: `1px solid ${message.success ? 'rgba(16,185,129,0.3)' : 'rgba(220,38,38,0.3)'}`,
              borderRadius: '7px', padding: '10px 12px', marginBottom: '16px',
            }}>
              <i
                className={`fa-solid ${message.success ? 'fa-circle-check' : 'fa-circle-exclamation'}`}
                style={{ fontSize: '13px', color: message.success ? '#10b981' : '#dc2626', flexShrink: 0, marginTop: '1px' }}
              />
              <span style={{ fontSize: '0.8rem', color: message.success ? '#6ee7b7' : '#fca5a5', lineHeight: 1.5 }}>
                {message.message}
              </span>
            </div>
          )}

          {message.success ? (
            <button
              onClick={() => navigate('/Login')}
              style={{
                width: '100%', padding: '11px', borderRadius: '7px', border: 'none',
                backgroundColor: '#dc2626', color: '#fff', fontSize: '0.85rem',
                fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em',
                cursor: 'pointer', transition: 'background-color 0.15s',
                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
              }}
              onMouseEnter={e => e.currentTarget.style.backgroundColor = '#b91c1c'}
              onMouseLeave={e => e.currentTarget.style.backgroundColor = '#dc2626'}
            >
              <i className="fa-solid fa-right-to-bracket" style={{ fontSize: '13px' }} />
              Iniciar sesión
            </button>
          ) : (
            <form onSubmit={handleSubmit}>
              {/* Password */}
              <div style={{ marginBottom: '16px' }}>
                <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: 600, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '4px' }}>
                  Nueva contraseña
                </label>
                <div style={{ position: 'relative' }}>
                  <i className="fa-solid fa-lock" style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', fontSize: '13px', color: '#64748b', pointerEvents: 'none', marginTop: '3px' }} />
                  <input
                    type={showPassword ? 'text' : 'password'}
                    value={form.password}
                    onChange={e => setForm({ ...form, password: e.target.value })}
                    style={inputStyle}
                    onFocus={e => { e.target.style.borderColor = '#dc2626'; e.target.style.boxShadow = '0 0 0 2px rgba(220,38,38,0.15)'; }}
                    onBlur={e => { e.target.style.borderColor = '#334155'; e.target.style.boxShadow = 'none'; }}
                    placeholder="••••••••"
                    required
                    minLength={8}
                  />
                  <button type="button" onClick={() => setShowPassword(p => !p)}
                    style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: '#64748b', padding: '4px', marginTop: '3px' }}>
                    <i className={`fa-solid ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`} style={{ fontSize: '13px' }} />
                  </button>
                </div>
              </div>

              {/* Confirm password */}
              <div style={{ marginBottom: '24px' }}>
                <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: 600, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '4px' }}>
                  Confirmar contraseña
                </label>
                <div style={{ position: 'relative' }}>
                  <i className="fa-solid fa-lock" style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', fontSize: '13px', color: '#64748b', pointerEvents: 'none', marginTop: '3px' }} />
                  <input
                    type={showConfirm ? 'text' : 'password'}
                    value={form.password_confirmation}
                    onChange={e => setForm({ ...form, password_confirmation: e.target.value })}
                    style={inputStyle}
                    onFocus={e => { e.target.style.borderColor = '#dc2626'; e.target.style.boxShadow = '0 0 0 2px rgba(220,38,38,0.15)'; }}
                    onBlur={e => { e.target.style.borderColor = '#334155'; e.target.style.boxShadow = 'none'; }}
                    placeholder="••••••••"
                    required
                    minLength={8}
                  />
                  <button type="button" onClick={() => setShowConfirm(p => !p)}
                    style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: '#64748b', padding: '4px', marginTop: '3px' }}>
                    <i className={`fa-solid ${showConfirm ? 'fa-eye-slash' : 'fa-eye'}`} style={{ fontSize: '13px' }} />
                  </button>
                </div>
              </div>

              <button
                type="submit"
                disabled={loading}
                style={{
                  width: '100%', padding: '11px', borderRadius: '7px', border: 'none',
                  backgroundColor: loading ? '#991b1b' : '#dc2626', color: '#fff',
                  fontSize: '0.85rem', fontWeight: 700, textTransform: 'uppercase',
                  letterSpacing: '0.06em', cursor: loading ? 'not-allowed' : 'pointer',
                  transition: 'background-color 0.15s', display: 'flex',
                  alignItems: 'center', justifyContent: 'center', gap: '8px',
                }}
                onMouseEnter={e => { if (!loading) e.currentTarget.style.backgroundColor = '#b91c1c'; }}
                onMouseLeave={e => { if (!loading) e.currentTarget.style.backgroundColor = '#dc2626'; }}
              >
                {loading
                  ? <><i className="fa-solid fa-circle-notch fa-spin" style={{ fontSize: '13px' }} /> Guardando...</>
                  : <><i className="fa-solid fa-key" style={{ fontSize: '13px' }} /> Restablecer contraseña</>
                }
              </button>
            </form>
          )}

          <button
            onClick={() => navigate('/Login')}
            style={{
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px',
              width: '100%', marginTop: '16px', background: 'none', border: 'none',
              cursor: 'pointer', color: '#64748b', fontSize: '0.78rem',
              transition: 'color 0.15s',
            }}
            onMouseEnter={e => e.currentTarget.style.color = '#94a3b8'}
            onMouseLeave={e => e.currentTarget.style.color = '#64748b'}
          >
            <i className="fa-solid fa-arrow-left" style={{ fontSize: '11px' }} />
            Volver al inicio de sesión
          </button>

          <p style={{ textAlign: 'center', fontSize: '0.72rem', color: '#475569', marginTop: '20px', marginBottom: 0 }}>
            IUMV — Sistema de Gestión Académica
          </p>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
